import React from 'react';

import Layout from '~components/layout';
import PageContent from '~containers/page-content';

const CustomerCare = props => {
  const {
    params: {selfLink},
  } = props;

  return (
    <Layout>
      <PageContent {...props} link={selfLink} />
    </Layout>
  );
};

export default CustomerCare;
